import { resolveImagePath } from '@/utils/imageMap';

export function Footer() {
  return (
    <footer className="bg-white">
      {/* Main Footer Section */}
      <div className="bg-gray-800 py-12">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-center">
            {/* Left Column - Company Info */}
            <div className="text-white">
              <h3 className="text-xl font-bold text-white mb-4">
                QUALITY AIRCRAFT MAINTENANCE
              </h3>
              
              <div className="space-y-2 text-sm">
                <div>
                  <span className="text-orange-400 font-semibold">OFFICE ADDRESS:</span>
                  <div>4316 Hangar Drive</div>
                  <div>Lexington, KY 40510</div>
                </div>
                
                <div className="pt-2">
                  <span className="text-orange-400 font-semibold">TELEPHONE:</span>
                  <div>
                    <a href="tel:18592551902" className="text-blue-400 hover:underline">
                      (859) 255-1902
                    </a>
                  </div>
                </div>
                
                <div>
                  <span className="text-orange-400 font-semibold">Broken Aircraft on Ground (AOG) 24hr #:</span>
                  <div>
                    <a href="tel:18592551902" className="text-blue-400 hover:underline">
                      (859) 255-1902
                    </a>
                  </div>
                </div>
                
                <div>
                  <span className="text-orange-400 font-semibold">AOG Parts:</span>
                  <div>
                    <a href="tel:18594960760" className="text-blue-400 hover:underline">
                      (859) 496-0760
                    </a>
                  </div>
                </div>
                
                <div>
                  <span className="text-orange-400 font-semibold">AOG Maintenance:</span>
                  <div>
                    <a href="tel:18592551902" className="text-blue-400 hover:underline">
                      (859) 255-1902
                    </a>
                  </div>
                </div>
                
                <div className="pt-2">
                  <span className="text-orange-400 font-semibold">E-MAIL:</span>
                  <div>
                    <a href="mailto:info@tbamky.com" className="text-blue-400 hover:underline">
                      info@tbamky.com
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* Center Column - Logo */}
            <div className="text-center">
              <img
                src={resolveImagePath('/images/logo.png')}
                alt="Thoroughbred Aviation Maintenance Logo"
                className="h-24 mx-auto"
              />
            </div>

            {/* Right Column - Certifications and Social */}
            <div className="text-center">
              {/* Beechcraft Authorization Section */}
              <div className="mb-4">
                <img
                  src="/images/authorized-beechcraft-piston-service-center-horiz.png"
                  alt="Authorized Beechcraft Piston Service Center"
                  className="w-full h-auto max-w-64 mx-auto"
                />
              </div>
              
              {/* Facebook Icon */}
              <div className="flex justify-center">
                <a
                  href="https://www.facebook.com/ThoroughbredAviationMaintenance/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-blue-800 hover:bg-blue-900 text-white p-3 rounded-full transition-colors"
                >
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright Section */}
      <div className="bg-blue-800 py-4">
        <div className="container mx-auto px-4">
          <div className="text-center text-white text-sm">
            © 2025 Thoroughbred Aviation Maintenance | All Rights Reserved |{' '}
            <a 
              href="https://thoroughbredaviationmaintenance.com/privacy/" 
              className="text-white hover:underline"
            >
              Privacy Policy
            </a>
            {' '}| Developed by{' '}
            <a 
              href="https://suite3marketing.com/" 
              target="_blank"
              rel="noopener noreferrer"
              className="text-white hover:underline"
            >
              Suite 3 Marketing
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}